import app from 'flarum/common/app';
export default async function purgeLSCache(tags, paths) {
  const queryParams = {};
  if (tags?.length) {
    queryParams.tags = tags;
  }
  if (paths?.length) {
    queryParams.paths = paths;
  }
  await app.request({
    url: `${app.forum.attribute('apiUrl')}/lscache-purge`,
    method: 'GET',
    params: queryParams
  });
  app.alerts.show({
    type: 'success'
  }, app.translator.trans(!tags?.length && !paths?.length ? 'acpl-lscache.lib.purge_all_success' : 'acpl-lscache.lib.purge_success'));
}
flarum.reg.add('acpl-lscache', 'common/purgeLSCache', purgeLSCache);